import React, { useState, useEffect } from 'react'
import {Col, Row} from 'antd'
import { useParams } from 'react-router-dom'
import FadeInOut from '@/components/FadeInOut'
import CaseLeft from './CaseLeft'
import CaseRight from './CaseRight'
import Bg01 from '@/assets/images/case/bg01.jpg'
import Bg02 from '@/assets/images/case/bg02.jpg'
import Bg03 from '@/assets/images/case/bg03.jpg'
import Bg04 from '@/assets/images/case/bg04.jpg'
import Bg05 from '@/assets/images/case/bg05.jpg'
import Bg06 from '@/assets/images/case/bg06.jpg'
import Bg07 from '@/assets/images/case/bg07.jpg'
import Bg08 from '@/assets/images/case/bg08.jpg'
import Bg09 from '@/assets/images/case/bg09.jpg'
import Bg10 from '@/assets/images/case/bg10.jpg'
import Bg11 from '@/assets/images/case/bg11.jpg'
import Bg12 from '@/assets/images/case/bg12.jpg'
import Banner02 from '@/assets/images/case/banner02.png'
import Banner03 from '@/assets/images/case/banner03.png'
import BannerJS from '@/assets/images/case/banner06.jpg'
import Banner04 from '@/assets/images/case/banner04.png'
import Banner05 from '@/assets/images/case/banner05.png'
import Client1 from '@/assets/images/home/client1.jpg'
import Client3 from '@/assets/images/home/client3.jpg'
import Client4 from '@/assets/images/home/client4.jpg'
import Client5 from '@/assets/images/home/client5.jpg'
import Client6 from '@/assets/images/home/client6.jpg'
import Client7 from '@/assets/images/home/client7.jpg'
import Client8 from '@/assets/images/home/client8.jpg'
import Client9 from '@/assets/images/home/client9.jpg'
import Client10 from '@/assets/images/home/client10.jpg'
import Client11 from '@/assets/images/home/client11.jpg'


const Case: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [data, setData] = useState([
    /*{
      name: '智臻未来-关键人才培养训练营',
      desc: '锚定新生关键人才，打造职业发展助力器',
      // banner1: Bg01,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：某大型民营集团化物业公司',
        desc: '该物业公司是中国最早一批接轨国际的物业公司，现正为20多家世界500强企业和50多家跨国公司、数十个写字楼、商务园、科技园、文创园、数字医院项目提供专业化、规范化、特色化的高品质物业管理服务，综合管理面积达500万平方米。'
      },
      backdrop: {
        title: '项目背景',
        desc: '该物业集团在行业内始终关注人才培养与组织梯队建设，人才梯队建设一直是该物业集团发展的关键点和核心。但随着公司规模扩大，众多Z时代员工加入，需要对关键人才进行更加系统化、针对化的培养，才能够充分发挥关键人才的优势，为未来管理晋升做好更强力的人才储备。“智臻未来”关键人才培养训练营在以上背景下开展，全力为企业培养人才，激发组织活力，促进各产品线/各业务线业务价值共生，加速第二曲线创新增长。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '遵循物业行业发展规律',
            desc: '通过研究物业行业发展趋势、挑战和规律，使项目符合物业行业的内在规律'
          },
          {
            name: '密连物业业务特点及企业文化',
            desc: '通过需求访谈调研了解该物业集团战略及业务重点，分析战略落地的关键瓶颈和障碍，使项目符合公司的战略重点，并符合文化特点'
          },
          {
            name: '契合学员的角色要求和岗位挑战',
            desc: '通过访谈调研，了解各层级关键人才的典型挑战、能力要求和现状，充分掌握目标人群的能力水平，匹配合适的课程内容和教学手段'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '本项目采用分阶段培养，通过课前调研+集中面授+课后研讨+训后实践，共四大项目阶段进行实施，项目为期6个月，培训时长11天。\n' +
          '培训主题分别为：合作共生、优势成长、智慧物业、创新思维、商务表达、创新大赛',
        pic: Client1
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            // name: '拉升业务视野 建立全局观念',
            desc: [
              '集团高管：通过结项课后作业，结项汇报等肯定项目价值',
              '培训对接人：探索项目模式，后续复制',
              '学员：领导力意识提升，加深了不同业务线条的联系和理',
            ]
          },
          // {
          //   name: '提高管理能力 增进团队凝聚',
          //   desc: [
          //     '项目放弃传统的纯讲授模式，频繁的研讨和小组共创，帮助学员消辑认知差异。\n能更顺畅的转换立场，需求共赢。',
          //     '在团队教练带领下，建立起未来协同中的“信任宣言”和“冲突契约”，为今后并肩作战打下坚实基础。',
          //     '关于团队人才管理的学习，帮助学员切实掌握人才供应链及梯队的建设方式，为提升人才厚度做好铺垫。',
          //   ]
          // }
        ],
        pic: Banner05,
        // pic2: Banner05
      }
    },*/
    {
      name: '金色传承·希望之星 高管继任项目',
      desc: '提升经营视野，建设继任梯队，加深人才厚度',
      // banner1: Bg02,
      recommend: {
        title: '公司介绍',
        tips: '公司性质：北京某大型国有黄金珠宝专营公司',
        desc: '该公司是商务部第一批命名的“中华老字号”企业，作国有控股企业，是西城区国资委的重要子企业。经过几十年的发展，该公司在黄金方面积累了丰富的经验，是北京市场收入规模领先的黄金珠宝企业，也是国内黄金珠宝商品的原料采购、款式设计、连锁销售和品牌运营珠宝行业中直营收入规模领先、单店收入规模领先，线线下全渠道经营的黄金珠宝专业经营公司。'
      },
      backdrop: {
        title: '项目背景',
        desc: '该公司在2022年成功上市，是其60余年企业发展的里程碑，也是企业第一代领导班子的成功写照。在上市后，该公司即将进入新老交替的阶段，面对疫情后多变脆弱的商业环境，以及上市后更为全面严格的企业治理要求，对新一代领导班子提出了更高更系统的能力要求。为了能更高效推进企业在新阶段的持续发展，帮助领导班子成员具备大局视野和经营格局，建设更完善的领导干部梯队，优化加深人才厚度，使企业精神能在传承中延续下去，该公司于2023年度开展系统性的领导干部培养项目，结合公司发展阶段以及企业业务特色，从思维到认知到行动，对领导干部梯队进行了全方位的发展和提升。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '公司目标',
            desc: '将公司品牌打造成具有国际竞争实力的优秀品牌，通过领军人才的培养，实现集团化公司发展'
          },
          {
            name: '组织目标',
            desc: '为实现公司战略目标提供人才保障，搭建中高层管理人才培养体系，增加人才储备'
          },
          {
            name: '人才目标',
            desc: '通过体系化和多元化的项目设计，实现公司中高层管理干部“能力-态度-认知”的跃迁'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '“人才强企、人才兴企”的人才培养理念，在本项目密结合企业认知 - 能力 - 态度三管齐下，全面提前期深入的调研基础上，从升管理干部的能力水平，建立高管梯队，从战略规划导入，辅以多重业务主题培训，并以行力学习贯穿全程，确保学习效果落地。认凝聚。同时引入团队教练，催化团队凝聚力。',
        pic: Banner02
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '拉升业务视野 建立全局观念',
            desc: [
              '项目以战略规划为起点，持续推动各个学员跳出职能局限，以一个经营者的视角全盘考虑业务发展，帮助学员切实掌握战略规划和解码的工具方法论。',
              '商业与经营主题的研讨，帮助学员俯瞰业务价值链，促成工作上下游的协调联动。',
              '紧贴业务主题的各项学习，帮助学员有了将各项业务方向扎实落地的抓手。',
            ]
          },
          {
            name: '提高管理能力 增进团队凝聚',
            desc: [
              '项目放弃传统的纯讲授模式，频繁的研讨和小组共创，帮助学员消辑认知差异。\n能更顺畅的转换立场，需求共赢。',
              '在团队教练带领下，建立起未来协同中的“信任宣言”和“冲突契约”，为今后并肩作战打下坚实基础。',
              '关于团队人才管理的学习，帮助学员切实掌握人才供应链及梯队的建设方式，为提升人才厚度做好铺垫。',
            ]
          }
        ],
        // pic: Banner03
      }
    },{
      name: '金色纽带、金色未来人才体系培养项目',
      desc: '完善管理人员培养体系建设，打造专业高素质干部队伍',
      banner1: Bg03,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：北京某大型国有黄金珠宝专营公司',
        desc: '该公司是商务部第一批命名的“中华老字号”企业，作为国有控股企业，是西城区国资委的重要子企业。经过几十年的发展，该公司在黄金珠宝商品的原料采购、款式设计、连锁销售和品牌运营等方面积累了丰富的经验，是北京市场收入规模领先的黄金珠宝企业，也是国内黄金珠宝行业中直营收入规模领先、单店收入规模领先，线上线下全渠道经营的黄金珠宝专业经营公司。'
      },
      backdrop: {
        title: '项目背景',
        desc: '近年来，珠宝行业呈现 “市场集中度提升、消费需求升级、数字化转型加速” 三大趋势，同时，当前黄金珠宝行业正在因“国朝年轻化的兴起”和“年轻消费者群体的崛起”重塑市场格局，这对品牌在产品创新、服务精细化与数字化运营方面提出了更为严苛的要求。该企业作为创立多年的中华老字号品牌，凭借 “诚信经营、全生命周期服务” 积累了 300 余万会员客户，但在战略落地过程中面临人才瓶颈：一方面，现有干部团队能力存在短板；另一方面，新聘任干部与高潜力人才需快速完成角色转型，适应门店扩张与业务创新需求。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '战略驱动：从区域标杆到全国引领',
            desc: '1、品牌影响力需全国性转化：传统优势如何有效转化为全国市场的持续竞争力。\n2、增长模式需系统性重构：在成功的直营连锁模式基础上，升级能支撑未来更复杂业务布局的集团化顶层设计与驱动引擎。'
          },
          {
            name: '组织与人才要求：构建可持续的人才供应链',
            desc: '1、高速扩张与深刻变革，将 “人才” 推至企业发展的核心。\n2、菜百股份需要的不仅是个别岗位的填补，更是一套能够系统化锻造、持续供给人才的 “生态型”培养体系，以支撑其从卓越零售公司向现代化产业集团的跨越。'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '“熙诚教育投资以解决 “现有干部能力短板” 与 “新人才角色适配” 两大痛点为导向，基于 “战略导向、问题解决、成果落地” 原则，两大模块分别聚焦不同培养目标，形成差异化设计：\n' +
          '→金色纽带项目：针对 2024 年 1 月前已任职的总监级、经理级、店长级等干部，通过 “业绩评估 + 能力测评 + 结构化面试”发现，在珠宝行业数字化转型、跨部门协同推进新品上架等场景中，干部存在跨部门资源整合、财务思维、风险意识、服务创新四大核心缺口，熙诚教育投资以 “补短板、提效能” 为核心，在跨部门协作、经营分析、风险管控、服务与创新四大能力上进行赋能；\n' +
          '→金色未来项目：针对新聘任干部、人才库成员、专柜负责人等群体，通过 “试用期表现跟踪 + 能力测评 + 业务调研” 发现，新聘任干部、专柜负责人等群体面临三大转型难题：角色认知模糊、门店运营实战能力不足、团队激励与客户服务技巧欠缺。熙诚教育以 “快速胜任、潜力激发”为核心，在角色转型、门店运营、团队管理三大方向进行知识赋能，分 A/B 班同步推进。\n' +
          '•项目遵循 “竞聘筛选 — 分组研讨 — 课程推进 — 课题落地 — 中期复盘 — 结营验收” 的全流程，以 “严管控、强互动、重落地” 为执行关键',
        pic: BannerJS
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '参与度与完成度：数据亮眼，态度积极',
            desc: [
              '高参与率：130 余位学员整体出勤率达 97%，仅 3% 因紧急业务请假，且均通过补课完成学习；',
              '高完成率：累计回收课后作业 900 余份，作业优秀率（90 分以上）达 90%；小组周会记录表 400 余份，课题进度跟踪覆盖率 100%；',
              '高专注度：“上交手机” 制度有效减少外部干扰。',
            ]
          },
          {
            name: '能力提升：干部思维与技能显著转变',
            desc: [
              '金色纽带：有效解决了新品采购与门店上架节奏衔接不畅的问题，让新品从供应链端到终端的流转效率显著提升；客服部结合所学内容，重新梳理客诉处理流程，通过建立更高效的响应机制，缩短了客诉解决周期，客户反馈满意度明显改善；',
              '金色未来：新聘任干部角色转型周期缩短，大部分学员能独立制定门店月度经营计划；专柜负责人通过业绩增长罗盘课程，使其所辖专柜销售额得到提升。',
            ]
          }
        ],
        // pic: Banner03
      }
    },{
    name: '鸿鹄-核心人才项目',
    desc: '树立创新管理新格局，实现管理干部能力再造',
    // banner1: Bg04,
    recommend: {
      title: '公司介绍',
      tips: '企业性质：国有清洁能源上市企业',
      desc: '该公司创建于1995年，2009年在香港联交所主板上市。2019年11月，公司获山东省属国有企业水发集团有限公司增资控股，成为水发集团布局粤港澳大湾区的国资控股港股上市公司。历经近30年的稳健发展和持续创新，公司逐步发展为专注清洁能源、绿色建筑、新型材料三大产业的高新技术企业集团，拥有8家一级权属公司，资产规模超200亿元人民币，成为行业重要参与者、贡献者、引领者。'
    },
    backdrop: {
      title: '项目背景',
      desc: '随着市场竞争的日益激烈，企业对于人才的需求也日益凸显。该公司作为一家实力雄厚的国有企业，深知人才对于企业发展的重要性。为更好地培养核心管理干部，提高企业整体竞争力，该公司推出了“鸿鹄”核心人才项目。'
    },
    target: {
      title: '项目目标',
      desc: '“鸿鹄”核心人才项目的目标是培养一支素质更高、能力更强、为企业发展发挥更大作用的新时代人才队伍，贡献新时代人才队伍的奋进力量。一是要以创新管理体系为学习的出发点，通过通不断学习来树立创新管理思维，为企业加快建立创新管理体系出点子、定策略，推动建成管理新格局，二要以解决实际问题着力点，三要以服务发展大局为学习的根本点，在学习中思考如何将所学所悟用于发展实践。',
      // descents: [
      //   {
      //     name: '公司目标',
      //     desc: '将公司品牌打造成具有国际竞争实力的优秀品牌，通过领军人才的培养，实现集团化公司发展'
      //   },
      //   {
      //     name: '组织目标',
      //     desc: '为实现公司战略目标提供人才保障，搭建中高层管理人才培养体系，增加人才储备'
      //   },
      //   {
      //     name: '人才目标',
      //     desc: '通过体系化和多元化的项目设计，实现公司中高层管理干部“能力-态度-认知”的跃迁'
      //   }
      // ]
    },
    pattern: {
      title: '项目模式及实施框架',
      desc: '此项目周期为三个月，共完成12天线下集中学习；4次面授，两次同步线上学习；1次拓展团建、1次企业研学、1次沙盘模拟、1次行动学习。\n' +
        '“鸿鹄”核心人才项目，在设计之初充分考虑了国企干部培养的能力模型与成长规律，紧密结合了水发兴业集团对核心管理干部的培训诉求，从政治素养、经营意识、财务敏锐、创新思维、团队领导等多视角出发，采用多元化的学习形式，进行内容设计。项目中充分融合了团队拓展、红色研学、集中授课、名企参访、研讨工作坊等体验式学习方式，犹如一个多元化的学习矩阵，不仅提供了一个全面的知识体系，还通过实践和体验，使学员得以深入理解和掌握知识，进一步提升其综合能力，且有利于培养出一批具有高度责任感和创新能力的管理干部，为企业的持续发展和提升竞争力提供坚实的支持。',
      pic: Client3
    },
    achieve: {
      title: '项目成果及价值评估',
      descents: [
        {
          name: '核心成果',
          desc: [
            '项目整体出勤率高达96%',
            '作业完成率100%',
            '产出《先锋学习成果展示板》报告',
            '落地26份《个人学习计划》',
            '产出5组课题报',
          ]
        },
        {
          name: '价值评估',
          desc: [
            '学员们在有限的时间内积极参与各项活动，努力提升自己的能力和素质。这种高投入度和专注力不仅体现了他们对项目的重视，还为项目的成功实施提供了有力保障。',
            '每期课程结束后，大家均积极高效的完成小组作业和个人作业。透过作业不仅锻炼了学员的实际操作能力，还通过数据分析发现了许多业务问题。这些数据为公司的决策提供了有力的支持，帮助学员更好地理解业务需求和目标。',
            '先锋学习成果报告不仅展示了学员的学习成果，还为公司提供了宝贵的经验和启示，有助于推动业务发展和创新。',
            '计划表不仅体现了学员的个人成长规划，还通过数据对比发现了每个学员的学习特点和优势。这些数据为公司的培训计划和人才发展提供了有益的参考，有助于更好地满足员工个人成长的需求。',
            '课题报告不仅展示了学员在解决实际问题中的能力，还通过分析和案例研究为公司解决实际问题提供了有效的方法和策略，有助于提高业务效率和降低成本。',
          ]
        }
      ]}
  },{
      name: '“添翼计划”中层干部培养项目',
      desc: '打造关键中层，百年茶饮品牌的人才破局之路',
      banner1: Bg05,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：国有企业',
        desc: '该企业始创于 1900 年，这家京城老字号是首批 “中华老字号”，其茉莉花茶制作技艺入选国家级非遗及人类非遗名录。\n' +
          '秉持 “诚信为本” 理念，聚焦茉莉花茶主业，在广西建标准化产业园，福建等地设 31 个生态茶基地，从源头把控品质。核心单品经八次窨花工艺制成，2024 年销售额突破 3.5 亿元，总店年销亦达 3.5 亿元。构建 “线上 + 线下” 格局，全国布局 400 余家连锁店，依托数字化系统与自动化生产线提升效率，建有 CNAS 认可检测实验室，持续传承茶文化。'
      },
      backdrop: {
        title: '项目背景',
        desc: '创立于 1900 年的中华老字号茶饮品牌，以茉莉花茶为核心优势，凭借百年品质坚守积累了深厚底蕴。但近年茶饮行业格局剧变：新消费品牌借年轻化营销与场景创新分流客群，消费者需求转向 “品质 + 体验 + 服务” 综合诉求，企业需加速数字化转型与产品创新以应对挑战，如推进生产线升级、布局电商直播等。\n' +
          '作为战略落地关键的中层管理者，却面临能力瓶颈：战略思维不足难适配转型方向，商业经营能力欠缺影响运营效率，创新意识薄弱难破传统模式，团队管理短板制约执行效能。为此，企业联合熙诚教育投资启动 “添翼计划”，旨在通过系统化培养破解瓶颈，支撑企业守正创新与战略落地。'
      },
      target: {
        title: '项目目标',
        desc: '熙诚教育投资基于该企业的战略目标与中层管理者的能力短板，项目整体设计以 “认知破局 - 能力强化 - 实战转化 - 落地保障” 为核心路径，分层破解四大能力短板。\n' +
          '项目围绕中层管理者 “战略认知、商业经营、创新突破、团队管理” 四大能力短板，设计 “四阶段递进式” 培养路径，各阶段环环相扣、层层深入。',
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '项目周期为一年，分段推进，采用 “理论授课 + 实战演练 + 社群运营 + 成果复盘” 的立体化实施模式，确保培训内容深度吸收与有效转化。熙诚教育投资全程参与项目设计与执行，通过 “课程线 - 运营线 - 成果线” 三线联动，保障项目效果：',
        pic: Client4
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '项目成果：数据亮眼，态度积极',
            desc: [
              '项目整体出勤率 100%，无人缺席核心课程',
              '每期课后考试整体平均分为9.6分（10分制）',
              '作业提交率 100%，其中 “优秀作业”（评分 80 分以上）占比 90%',
              '社群活动参与率 90%，共产出 “优秀知识导图 6 份”“短视频方案 11 条”“草点营销方案 5 份”，其中 3 条短视频已在企业小红书账号发布',
            ]
          },
          {
            name: '价值评估：中层思维与技能显著转变',
            desc: [
              '战略思维提升：大部分学员反馈 “能够清晰解读企业战略，并有效分解为部门具体任务”',
              '商业经营能力提升：《升弈OMC®商业沙盘模拟》课程后，学员反馈 “掌握了成本核算与市场决策的技巧和方法”，业务部门能够据此优化 “门店库存管理流程”，有效减少滞销库存，降低成本',
              '创新能力提升：帮学员构建 “用户需求到爆品落地” 认知框架，通过实战提升需求分析与方案设计能力，沉淀5份爆品营销方案，为企业产品创新提供方法与灵感',
              '团队领导力提升：学员反馈 “团队协作效率提升”，如市场部与门店管理部中层通过 “跨部门沟通技巧”，在推动 “新品试销活动” 中减少很多不必要的冲突和时间的浪费',
            ]
          }
        ]}
    },{
      name: '“臻远计划二期”-人才培养项目',
      desc: '实现从“人力成本”到“人力资本”的升级！',
      banner1: Bg06,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：国有企业',
        desc: '该公司成立于2004年，是一家以资本运营为核心、多元化产业投资为基础的综合性企业集团。公司总部设有完善职能管理部门，旗下拥有多家子公司，业务布局主要涵盖工业制造、物业服务、资本运营三大核心领域。在工业制造板块，公司拥有为国家重点工程配套的"专精特新"企业，具备完整的研发制造能力；物业服务板块提供全周期的专业化物业管理服务；资本运营板块通过专业的投资管理，推动各产业协同发展。凭借跨行业资源整合能力和持续创新，公司已在高端制造、城市服务等领域建立起显著的行业影响力，形成了产业深度与投资广度并重的发展格局。'
      },
      backdrop: {
        title: '项目背景',
        desc: '战略与组织发展需求：为纵深推进新时代人才强企战略，世纪金工围绕企业战略经营发展规划，进行了组织人才结构及人才发展理念的革新与强化。当前正处于“十四五”收官、即将迈进“十五五”规划的关键阶段，公司致力于重塑人才教育培养体系，巩固过去成功的关键因素，确保人才供应链具备持续造血能力，为实现百年企业愿景筑牢人才基石。\n' +
          '人才培养的紧迫性：面对全球经济环境与产业竞争的复杂变化，以及市场竞争加剧、客户需求多变、人才流失等多重挑战，世纪金工亟需培养一批具备复合型经营管理能力的青年骨干人才。这批人才将支撑公司战略落地，提升组织承接战略变革的能力，并推动企业在激烈市场竞争中持续发展。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '支撑战略落地',
            desc: '明确公司战略对管理者的核心要求，以实现战略经营目标为出发点，提升青年骨干的战略理解与承接能力'
          },
          {
            name: '补齐能力短板',
            desc: '明确复合型人才的核心能力模型，通过三年周期系统化培养，补齐青年骨干在经营管理方面的能力差距'
          },
          {
            name: '激发组织活力',
            desc: '通过横向学习、思维碰撞，激发青年骨干的创新思维与相互影响，提升组织的整体活力与战斗力'
          },
          {
            name: '加速人才成长',
            desc: '促使青年人才快速成长，适应市场变化与公司运营机制，完成从个人贡献者到团队管理者的视角与能力转换'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '本年度作为三年长周期培养的「筑基」之年，项目设计将遵循“实践赋能、阶梯考核、档案追踪”的核心逻辑，构建「学习-实践-评估」的闭环培养体系。通过集中授课提升思维与技能，结合返岗实践促进知识转化，并借助读书会、内部导师、行为观察等多元运营机制，深化学习效果，实现从个人能力提升到组织绩效改进的赋能路径。\n' +
          '2025年项目周期为全年，计划开展集中培训共9天，涵盖团队融合、素养提升、思维提升与技能提升四大模块；课后实践活动共3类，包括读书会、年度述能汇报及课题驱动的返岗实践。',
        pic: Client5
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '核心成果',
            desc: [
              '学员发展层面：累计产出109份高质量学习成果，形成10份深度小组读书报告，完成37份全周期导师辅导记录，并通过37场结构化述能汇报全面展示个人成长与能力提升',
              '运营支持层面：设计并发布5期“学习加油站”主题海报，持续营造学习氛围，强化项目品牌影响力，为学员提供贯穿全程的视觉化学习引导与动力支持',
            ]
          },
          {
            name: '价值评估',
            desc: [
              '人才数据资产化：通过109份学习成果、37份导师记录与述能报告，建立可量化、可追踪的人才数据库，为选拔与梯队建设提供依据',
              '知识成果体系化：读书报告与学习海报将个人学习转化为组织知识资产，促进经验沉淀与文化传承',
              '学用闭环实效化：依托“导师+实践+汇报”机制，推动学习成果向岗位行为与业务绩效转化，形成从输入到输出的完整闭环',
            ]
          }
        ]}
    },{
      name: '后备干部三年培养项目二期',
      desc: '打造复合型、高素质的“平台化操盘者”人才梯队',
      banner1: Bg07,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：北京某大型国有集团化资本公司',
        desc: '该集团为区国资委全资拥有的国有资本市场化运营专业平台。2017年，区国资委对该集团实施战略重组，并赋予“授权经营、投资引领、资产重组、协同发展及服务区域战略”五大平台功能。重组至今，该集团已明确了打造“产业资本与金融资本融合发展”的企业战略目标，重新梳理主营业务，构建“投资引领与产业培育”双轮驱动模式，在促进国有资本布局结构优化、培育孵化战略性新兴产业、推动国资国企深化改革等方面取得积极成效，有效提升了国有资本服务区域经济社会发展的能力。截至2021年12月31日，总资产约3,060亿元，净资产约979亿元，2021年度完成营业收入约513亿元，利润总额约40亿元。主体信用评级为AAA。'
      },
      backdrop: {
        title: '项目背景',
        desc: '面对集团“投资引领与产业培育”双轮驱动的战略发展方向，组织对人才的能力提出了新的要求。后备人才亟需具备复合型知识结构、全局视角与专业能力，并逐步向“平台化操盘者”转型。因此，本项目旨在通过系统化的培养，为集团高质量发展提供坚实的人才梯队支撑。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            desc: '采用 “测 - 训 - 练 - 评” 一体化设计，保障后备人才培养实效，夯实项目启动基础'
          },
          {
            desc: '实施分序列精准培养，提升培养针对性'
          },
          {
            desc: '以 “训战结合” 为核心，确保学员所学知识可落地、能应用'
          },
          {
            desc: '启动导师辅导机制，借助导师实战经验加速后备人才成长'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '为确保培养实效，项目采用了“测-训-练-评”一体化的设计思路。作为启动元年，项目设计着重突出了三大亮点：\n' +
          '亮点一：分序列培养，提升精准度\n' +
          '项目打破“大锅饭”模式，将后备人才分为两大序列进行精准培养 ：\n' +
          '管理序列： 聚焦培养学员的系统全局思维、团队管理能力和资源协同能力，打造高素质管理团队。\n' +
          '门店管理序列： 注重“专业精深 + 管理通识” ，培养复合型专业人才。\n' +
          '亮点二：训战结合，学以致用\n' +
          '项目强调“训战结合、成果落地” 。在实施的第一年，重点在于“训”，即系统化的能力学习 。学员在完成集中学习后，鼓励学员带着所学知识与工具回到工作岗位进行实践，并将在未来通过实践成果汇报来检验“战”的成效，形成“学-习-用”的闭环。\n' +
          '亮点三：导师辅导，加速成长\n' +
          '为帮助学员将所学知识与个人发展紧密结合，项目成功启动了导师辅导机制。基于前期的能力测评结果，导师将辅导学员制定个性化的IDP（个人发展计划），明确发展目标、阶段任务和成果标准。这一机制旨在通过导师宝贵的实战经验和指导，加速后备人才的成长速度。',
        pic: Client6
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            desc: [
              '完成了系统性内容学习',
              '两大序列学员均完成了预定的核心课程学习 ，为后续的实践应用储备了充足的理论知识',
              '成功启动了导师机制',
              '项目顺利落地了导师辅导机制，所有学员均在导师的指导下确立了清晰的个人发展计划（IDP）',
              '奠定了“训战结合”的基础',
              '通过第一年的“训”，为后续的“战”（实践应用与成果落地 (44)）做好了充分准备',
            ]
          }
        ]}
    },{
      name: '“西融人才”国情研修班',
      desc: '凝聚高层次人才力量、激发创新创造活力',
      banner1: Bg08,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：机关单位',
        desc: '该单位聚焦党建与人才核心工作，以规范化建设和精准化服务为抓手，为区域发展提供坚实保障。核心负责基层党组织建设，覆盖多领域党组织换届、结构优化与党员教育管理，严把党员发展质量关。统筹干部队伍全周期建设，包括选拔任免、考核评价、教育培训及年轻干部、各类专项干部培养。牵头推进人才工作，协调落实人才政策，开展引进、培养与服务工作。通过健全机制、创新举措，持续优化队伍结构、强化组织功能，助力基层治理与区域高质量发展。'
      },
      backdrop: {
        title: '项目背景',
        desc: '当前，我国正加快推进世界重要人才中心和创新高地建设，《国家中长期人才发展规划纲要（2021-2035 年）》明确提出要强化高层次人才引领作用，推动人才与产业、区域发展深度融合。作为首都核心区，西城区肩负着服务国家战略、引领高质量发展的重要使命，其 “西融计划” 作为重点人才品牌工程，已构建起 “引育用留” 全链条人才生态，但在推动高层次人才跨界协作、助力人才精准服务区域产业发展方面仍需进一步突破。\n' +
          '基于此，熙诚教育投资协同该单位开展“西融计划” 国情研修班，旨在通过系统化研修，帮助高层次人才精准把握国家及区域人才战略方向，搭建跨界交流桥梁，借鉴标杆企业发展经验。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            desc: '以 “战略契合、需求导向、实效落地” 为核心原则，围绕 “政策认知-协作共建-产业互通-实践赋能” 四大维度设计研修体系，确保内容与人才需求、区域发展目标高度匹配。'
          },
          {
            desc: '1. 政策认知维度：帮助学员清晰把握人才工作新形势、新方向，理解区域人才政策红利。'
          },
          {
            desc: '2. 产业互通维度：打造 “人才讲产业、人才谈事业、人才道国情” 特色模块。'
          },
          {
            desc: '3. 协作共建维度：设置晚间深度研讨环节，推动跨行业资源整合与合作意向落地。'
          },
          {
            desc: '4. 实践赋能维度：引入 “标杆企业参访 + 前沿技术分享” 环节，帮助学员将理论认知转化为实践参考。'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '该研修项目以 “精准筹备、高效执行、沉淀联结” 为核心，分三阶段有序推进。\n' +
          '前期通过与相关单位沟通明确学员核心需求，优化研修内容、敲定嘉宾与参访企业，同时完善培训基地保障、定制专属物料并统筹人员分工，为项目落地筑牢基础。\n' +
          '研修执行阶段多维联动，邀请权威专家与区域领导开展政策解读，明晰人才战略与区域政策；聚焦 “人才讲产业、谈事业、道国情” 开展跨界分享，覆盖多领域实践经验；研修期间配套晚间分组研讨与晨间八段锦教学，凝聚发展共识并保障学员状态；组织字节跳动前沿技术分享与菜百股份参访，助力学员借鉴企业实践经验。\n' +
          '结营阶段举办结业仪式，总结成果、鼓励学以致用，同时发放定制纪念相册，强化学员情感联结，圆满完成研修目标。',
        pic: Client7
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '参与度与满意度双高',
            desc: [
              '研修班初始参训 47 人，全程参训率较高；通过课后抽样访谈，学员对政策解读、跨界分享、企业参访的满意度均超过95%，认可研修内容的实用性与针对性。',
            ]
          },
          {
            name: '产出多项实操建议',
            desc: [
              '晚间研讨共收集学员提出多条人才发展与产业合作建议，涵盖跨领域平台搭建、技术落地场景拓展、人才培养模式创新等方面，部分建议已被西城区委组织部纳入人才工作参考资料。',
            ]
          },
          {
            name: '推动跨行业协作',
            desc: [
              '各业的优秀人才汇聚在一起，学员们普遍认为，本次研修班不仅拓展了视野、提升了素养，更促进了人才之间的资源对接与项目合作，为共同服务西城高质量发展注入了新动力。',
            ]
          },
          {
            name: '提升人才政策认知与实践能力',
            desc: [
              '大部分学员反馈，通过研修清晰掌握了国家人才战略核心与西城人才政策细节，同时借鉴了标杆企业的发展经验与跨领域人才的实践思路，后续将更精准地结合自身工作服务区域发展。',
            ]
          }
        ]}
    },{
      name: '超大规模全线上训练营',
      desc: '云端实战・AI破局 —— 打造金融业数字化转型核心引擎',
      banner1: Bg09,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：全国性股份制商业银行',
        desc: '该公司为某大型股份制商业银行商业银行作为国内系统重要性银行，在全球银行业中保持领先地位。该行始终坚持数字化战略导向，积极推动科技与金融的深度融合。\n' +
          '凭借覆盖全国的服务网络和先进的科技赋能体系，该行已构建起线上线下协同发展的现代金融服务生态。在最新财报中，该行集团总资产规模达十万亿元级别，经营业绩持续稳健，其卓越的ESG实践更获得国际权威机构的高度认可。\n' +
          '目前，该行已构建覆盖全国、辐射海外的服务网络，并通过科技赋能，建立了完善的线上线下协同发展的现代化金融服务体系。'
      },
      backdrop: {
        title: '项目背景',
        desc: '在数字经济浪潮与金融科技深度融合的时代背景下，该国有大行将人工智能与数据能力建设提升至全行战略高度。系统性开展AI赋能训练营，源于以下三大战略洞察：\n' +
          '一、政策引领：数字化转型进入深度实施阶段：伴随《金融科技发展规划（2025-2030年）》及监管部门相关指引的密集出台，数字化转型已从“前瞻布局”升级为“刚性需求”，成为衡量银行未来发展潜力的关键指标。\n' +
          '二、技术驱动：AI与数据要素重塑行业格局：人工智能与数据要素正深度重构金融服务模式与竞争壁垒，技术赋能成为实现业务提质、降本、增效的核心手段，是打造未来竞争力的关键引擎。\n' +
          '三、人才支撑：复合型能力决定战略落地成效：数字化战略的最终实现，依赖于既精通业务又掌握技术的复合型人才梯队，亟需通过体系化、规模化培养，锻造一批既精通业务又熟悉技术的复合型骨干。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            desc: '助力全行数字化战略落地，为银行数字化转型构建坚实的人才基座。'
          },
          {
            desc: '提升全行员工数字素养、AI 应用能力及创新思维，支撑银行在行业竞争中保持领先优势。'
          },
          {
            desc: '突破单纯技能培训的局限，实现人才培养与数字化战略的深度绑定，保障转型落地实效。'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '基于对银行数字化战略的深度理解，本项目构建了“认知-技能-实战-转化”四阶赋能体系，将AI能力建设与业务价值创造紧密融合。\n' +
          '阶段一：全员启航｜构建统一AI认知基座\n' +
          '核心目标：建立3800名学员对AI技术的统一认知框架\n' +
          '关键动作：系统解读AI基本原理、行内数据规范及大模型应用策略\n' +
          '阶段二：工具突围｜掌握智能办公实战技能\n' +
          '核心目标：赋能学员熟练运用DeepSeek等智能工具提升工作效率\n' +
          '关键动作：聚焦高效提问、数据分析、智能写作等高频办公场景\n' +
          '阶段三：实战攻坚｜驱动业务价值深度创造\n' +
          '核心目标：推动AI技术在核心业务场景的深度融合\n' +
          '关键动作：围绕智能营销、风险预警、客户服务等8大高频业务场景展开实战\n' +
          '阶段四：价值落地｜实现成果规模化转化\n' +
          '核心目标：产出可评估的“AI+数据”业务解决方案\n' +
          '整个项目设计遵循“知行合一”的赋能逻辑，确保能力提升路径与贵行数字化战略目标高度同频，最终为全行系统化培养“懂业务、通技术、善实战”的复合型数字人才。',
        pic: Client8
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '项目成果',
            desc: [
              '数据维度：【数据矩阵图】\n' +
              '参与：3800 人 | 结业：1021 人（通过率 93%）\n' +
              '练习提交：4000 人次 | 实战作业：125 份 | 优秀学员：60 位',
              '认知维度：业务结果\n' +
              '实现全行数智化转型的认知协同与语言统一\n' +
              '激发员工新技术学习热情与主动探索意识\n' +
              '重塑工作逻辑与执行范式，推动从重复性劳动向创造性工作跃迁'
            ]
          },
          {
            name: '价值评估',
            desc: [
              '全线上闭环：云端开营→直播授课→在线答疑→线上演练→云端结营',
              '三维教学：在线学习 + 随堂练习 + 实践演练，配套数字化资源',
              '超规模服务：百人讲师团 + 4 名班主任 “秒级响应”+3800 人社群运营',
              '积分激励：标准化学分制，提升优秀学员比例，激发学习热情',
            ]
          }
        ]}
    },{
      name: '“É未来”领航者训练营',
      desc: '领航经营之路，陪跑成长之变',
      banner1: Bg10,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：民营/有限责任公司',
        desc: '该企业是一家快速发展的民营冷冻烘焙食品企业，总部位于上海，是国内冷冻烘焙领域的领先者。公司专注于瑞士卷、千层蛋糕等产品的研发、生产与销售，凭借强大的产品研发和爆品打造能力，与山姆会员商店等知名渠道建立了深度合作，实现了快速的业务增长。'
      },
      backdrop: {
        title: '项目背景',
        desc: '该企业领航计划基于对中高管团队现状的深入分析，针对管理经验不系统、内部管理语言不统一、跨部门协作不畅等痛点，结合外部领导力角色要求，旨在通过系统化培养提升中高管的全局视野、经营思维与团队引领能力，推动组织协同与战略落地。'
      },
      target: {
        title: '项目目标',
        desc: '本项目旨在通过系统性的培养与陪跑，帮助该企业中高管团队统一内部管理语言，打破部门壁垒，并实现从管理者到经营型高管的角色转变。核心目标是系统提升高管团队的全局视角、经营思维、团队引领和开放协作能力，从而打造一支具备战略共识、能协同作战、推动组织持续发展的核心领导梯队。',
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '本项目周期贯穿2025年至2026年初，以“经营型高管陪跑”为核心逻辑，通过四次主题式集中赋能，累计完成8天线下学习，并融入2次标杆企业参访。\n' +
          '项目设计紧密围绕中高管从专业管理到经营引领的成长路径，系统覆盖全局视野、经营思维、团队引领、开放创新四大关键维度。实施中充分结合了战略面授、领导力发展、商业沙盘、创新工作坊、跨界参访（胖东来/施耐德）与结营复盘等多元学习形式，构建起“学-思-践-悟”闭环。该框架不仅强化了高管团队的战略共识与协同语言，更通过实战模拟与标杆对照，促进经营理念的内化与落地，系统性锻造能引领业务持续增长的核心领导梯队。',
        pic: Client9
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '项目成果',
            desc: [
              '本项目通过系统化运营与全程陪跑，实现高质量交付：学员满意度达4.85/5分，全程参与率100%，累计输出33份可落地的领导力实践方案及19项降本增效改进计划，覆盖采购、生产、物流等关键业务环节，实现从学习到实践的有效转化。'
            ]
          },
          {
            name: '价值评估',
            desc: [
              '项目从组织、团队、个人三个层面实现显著价值跃升',
              '在组织层面，统一了内部管理语言，强化了战略共识与协同文化；在团队层面，通过4D领导力等工具的系统应用，显著降低了沟通成本，提升了跨部门协作效能；在个人层面，学员完成了从管理者到经营者的角色转变，建立起以数据为支撑的经营思维体系，为企业持续发展构建了坚实的领导力基础',
            ]
          }
        ]}
    },{
      name: '头部外企的战略客户经营实战',
      desc: '从市场噪声中识别信号，从产品同质中实现破局',
      banner1: Bg11,
      recommend: {
        title: '公司介绍',
        tips: '德资企业、全球行业技术领袖、世界500强成员',
        desc: '核心领域：传动与控制技术\n' +
          '企业定位：该公司作为全球知名的传动与控制技术专家，在工程机械、工业自动化及移动机械领域占据技术领导地位。公司拥有平均从业经验超过20年的资深技术团队，长期为国内顶尖客户提供系统解决方案\n' +
          '凭借德国制造的技术积淀与持续创新能力，该公司在高端液压市场保持技术领先地位，其产品以卓越的可靠性、精准的控制性能和长效的使用寿命赢得全球客户信赖'
      },
      backdrop: {
        title: '项目背景',
        desc: '背景：\n' +
          '国产化替代\n' +
          '国产低成本优势\n' +
          '国产化技术差距不断缩小\n' +
          '产业下游需求大幅收缩\n' +
          '客户全面降本战略\n' +
          '本地化供应链和服务更及时\n' +
          '国内同行为民企500强第三位，\n' +
          ' 产值近万亿（8715万）\n' +
          '国内价格政策机制灵活……\n' +
          '\n' +
          '挑战：\n' +
          '世界顶级外企\n' +
          '价格高于国内30%+\n' +
          '行业积累和技术更先进\n' +
          '进口部件交货周期长达数月\n' +
          '业务团队平均工龄超过20年\n' +
          '高精尖项目客户邀约设计研发，\n' +
          '一旦进入规模化装机量产，\n' +
          '约大部分配额就交由国内企业供应\n' +
          '团队士气和发展信心不足……'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '解决业务核心痛点',
            desc: '助力博世力士乐突破经济环境变化、客户需求升级、市场竞争加剧带来的发展瓶颈，将资深员工碎片化经验转化为系统化商业思维，掌握客户需求深度洞察与差异化竞争的全新业务打法，破解产品同质、护城河变绊脚石的行业难题。'
          },
          {
            name: '构建核心能力体系',
            desc: '帮助学员建立从行业趋势洞察到产品规划落地的全链路能力，涵盖战略洞察、客户拜访、复盘验证、洞察与产品规划等核心环节，实现发展驱动、业务模式、人员能力的三重转型。'
          },
          {
            name: '实现客户价值共创',
            desc: '从单纯的产品销售转向深度客户经营，深耕现有客户、提升本土研发产品市场占有率、赋能客户出海，与战略大客户建立价值共生的合作关系，筑牢博世力士乐全球领先的市场地位。'
          },
          {
            name: '沉淀可复制方法论',
            desc: '通过训战结合的方式，形成一套适配博世力士乐业务场景的客户经营、拜访实战、产品规划方法论与工具体系，实现能力落地与经验固化，支撑业务可持续发展。'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '01.战略洞察（起始幕）\n' +
          '- 行业趋势洞察\n' +
          '- 客户战略解读\n' +
          '- 应用需求梳理\n' +
          '- 核心产出：客户战略需求清单\n' +
          '02.客户拜访（互动幕）\n' +
          '- 客户随访实战\n' +
          '- 需求摸排验证\n' +
          '- 确认需求信息\n' +
          '- 核心产出：获取客户信息的能力\n' +
          '03.复盘验证（关键幕）\n' +
          '- 实践应用反馈\n' +
          '- 方法论迭代优化\n' +
          '- 成功案例沉淀\n' +
          '- 核心产出：可复制的实战方法论\n' +
          '04.洞察与产品规划（新篇章）\n' +
          '- 行业需求洞察\n' +
          '- 需求产品拉通\n' +
          '- 制定规划策略\n' +
          '- 核心产出：产品初步规划',
        pic: Client10
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            name: '项目成果',
            desc: [
              '（一）学员能力与业务落地成果\n' +
              '1. 完成多阶段实战工作坊落地，涵盖行业洞察、战略客户洞察、产品规划等模块，累计开展多班次线下实战，结合线上复盘辅导，实现从理论到实战的全流程赋能。\n' +
              '2. 产出系列高价值业务文档，包括10 + 份战略客户经营计划书、《行业洞察分析报告》《产品规划设计》《战略客户 - 拜访沟通计划及复盘》等，直接指导一线业务开展。\n' +
              '3. 学员掌握客户拜访全流程实操能力，能独立完成拜访准备、实战走访、需求验证、复盘总结，形成标准化的客户对接与需求挖掘能力。',
              '（二）工具与方法论沉淀成果\n' +
              '1. 打造1 套战略经营方法论，形成从行业趋势到产品规划、从客户洞察到商机跟进的全链路业务逻辑。\n' +
              '2. 开发1 套客户拜访实战工具箱，包含 SOP 流程、拜访复盘表、提问清单、独特差异优势表、行动计划制定表等标准化工具，实现业务动作的可复制、可落地。',
              '（三）客户经营与业绩增长成果\n' +
              '1. 与中联重科等战略大客户开展技术共创工作坊，达成深度合作共识，客户反馈评分均在 4.6 分以上，双方确定多项后续合作落地计划。\n' +
              '2. 助力博世力士乐实现业绩逆势增长，订单增长 30%、销售额增长 13%、利润增长 4.1%，2025 年上半年完成全年 70% 业绩目标，团队士气与战略信心显著提升。',
              '（四）项目合作与业务拓展成果\n' +
              '1. 实现博世内部客户裂变，成功转化博世力士乐 - 常州、博世中国培训中心、博世汽车 3 个内部新客户。\n' +
              '2. 锁定 2026 年博世力士乐北京咨询项目，实现从培训服务到轻咨询、全咨询的业务升级，北京工厂营收达 31 亿，占中国区 44% 比重，实现高含金量增长。'
            ]
          },
          {
            name: '价值评估',
            desc: [
              '能力价值：推动企业从 “产品导向” 向 “客户价值导向” 转型，实现管理层、产品研发、大客户销售、技术应用等跨职能人员的商业思维系统化升级，打造了一支具备客户深度洞察与差异化竞争能力的核心团队。',
              '业务价值：直接带动业绩逆势增长，同时深耕战略大客户实现价值共生，筑牢了全球传动与控制技术领袖的市场地位，为本土研发产品市场占有率提升、客户出海赋能奠定了坚实基础。',
              '组织价值：沉淀了一套可复用、可迭代的客户经营与产品规划工具方法体系，成为企业的核心知识资产，支撑组织能力的持续提升与业务的可持续发展。',
              '为高端制造行业数字化、智能化转型背景下的企业培训提供了可参考的实践范本，验证了 “训战结合、价值共创、成果落地” 培训模式的有效性。',
              '提出了 “客户经营是和客户一起养母鸡” 的理念，为行业从单纯的产品销售转向深度客户价值共创提供了思维与方法参考，推动行业业务模式的升级。',
            ]
          }
        ]}
    },{
      name: '中药领军企业第二届创新技控大赛',
      desc: '五位一体培养模式赋能、技控大赛打造创新练兵场',
      banner1: Bg12,
      recommend: {
        title: '公司介绍',
        tips: '企业性质：国有企业',
        desc: '创制于1902年，是业内公认中华老字号最具有创新力的代表。作为拥有121年历史的中华老字号民族品牌，该企业始终致力于推动传统中医药融入现代生活，持续深挖传统医学产品的内生潜力，以产品创新回应现代生活需求，不断为传统品牌及传统中医药产品注入新的生命力。'
      },
      backdrop: {
        title: '项目背景',
        desc: '面对全球经济变革与产业升级浪潮，该集团积极响应国家“大国工匠”政策号召，以“人才培养”与“提质增效”为核心，正式启动第二届全员创新技控大赛。本届大赛将通过赛训结合、实践创新，激发技术潜能，沉淀智慧成果，为高质量发展注入新动能，在智能制造时代铸造核心人才竞争力。'
      },
      target: {
        title: '项目目标',
        descents: [
          {
            name: '知识赋能',
            desc: '系统性技术培训 + 行业专家指导，夯实技能基础'
          },
          {
            name: '实战练兵',
            desc: '真实场景课题 + 创新技控方案，破解技术痛点'
          },
          {
            name: '成果落地',
            desc: '优秀项目孵化 + 技控手册输出，激活长效价值'
          },
          {
            name: '人才沉淀',
            desc: '导师认证体系 + 人才库建设，构建可持续发展生态'
          }
        ]
      },
      pattern: {
        title: '项目模式及实施框架',
        desc: '2024年白药启动首届技控大赛，培养了30名技控导师，产出100个优秀课题，带来上千万经济效益\n' +
          '2025年在首届大赛的基础上，持续为导师赋能，提升导师辅导能力，产出80个优秀课题，同时产出白药技控手册',
        pic: Client11
      },
      achieve: {
        title: '项目成果及价值评估',
        descents: [
          {
            desc: [
              '经济效益：收集有效课题87个，累计给白药带来上千万经济价值，实现了内部流程优化、工艺创新、质量提升；',
              '文化形成：持续的技控项目，打造了白药学苑典型项目IP，激发了人人技控氛围，传承全员创新精神；',
              '经验沉淀：本项目输出白药内部技控手册1.0，知识经验内化沉淀白药技控经验，帮助白药人解决岗位工作痛点，实现快速降本增效；',
              '队伍培养：通过两届技控大赛培养了18位内部技控导师队伍，构建了白药内部可持续的人才发展生态，为白药持续发展提供优秀人才储备。',
            ]
          }
        ]}
    }
  ])
  const [Item, setItem] = useState(data[0])
  const { id } = useParams()

  useEffect(() => {
    setIsVisible(true)
    setItem(data[id || 0])
  }, [])

  const changeData = (newItem) => {
    setItem(newItem)
    setIsVisible(false)
    setTimeout(() => {
      setIsVisible(true)
    }, 100)
  }

  return (
    <main className='wrap-case header-top'>
      <Row className='wrap-case-content home-page'>
        <FadeInOut isVisible={isVisible}>
          <CaseLeft item={Item} />
        </FadeInOut>
        <CaseRight data={data} idx={id || 0} changeData={changeData} />
      </Row>
    </main>
  )
}

export default Case